import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { ToastContainer } from "react-toastify";
import { showCustomAlert } from "../../../../../customComponents/CustomSweetAlert";
import Loader from "../../../../../customComponents/CustomLoader";


const EditLeadStatus = () => {
  const token = localStorage.getItem("authToken");
  const [formData, setFormData] = useState({});
  const location = useLocation();
  const { data } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [editLeadStatus, setEditLeadStatus] = useState([]);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [ userTypedd, setUserTypedd ] = useState([])
  const userType = localStorage.getItem("UserType")
  const businessPartnerId = localStorage.getItem("business_partner_id")


  useEffect(() => {
    userTypedropdown()
  },[])
  
  const userTypedropdown = async () => {
    try{
      const response = await axiosInstance.get("/bp-onboard/bplist",{
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
  
      const data = response.data.data.data
      const userTypeOptions = data.map(user => ({
        value: user.onboard_id,
        label:user.bp_name,
      }))
      setUserTypedd(userTypeOptions)
    }catch(error) {
      console.log(error)
    }
  }



  useEffect(() => {
    fetchLeadStatusEdit();
  }, []);


  const navigate = useNavigate();

  const fetchLeadStatusEdit = async () => {
    try {
      const response = await axiosInstance.get(`/status/edit/${data.status_id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const fetchedData = response.data.data; 
      const formatedData = {
        status_name:fetchedData.status_name,
        status_desc:fetchedData.status_name,
        status: fetchedData.status === 1 ? "Active" : "Inactive",
        business_partner_id:fetchedData.business_partner_id
      }
      setFormData(formatedData)
      setEditLeadStatus(fetchedData);
      console.log("fetchedData", fetchedData);
    } catch (error) {
      console.log(error);
    }
  };

  const handleFormSubmit = async (formData) => {
    try {

      const payload = {
        status_name: formData.status_name,
        status_desc: formData.status_desc,
        status: formData.status === "Active" ? 1 : 0,
      }

      if (userType === "superadmin") {
        payload.business_partner_id = formData.business_partner_id;
      } else {
        payload.business_partner_id = businessPartnerId;
      }

      setIsFormSubmitted(true);
      console.log("Form Data:", formData);

      await axiosInstance.patch(`/status/update/${data.status_id}`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      console.log("Update successful!");
      

      showCustomAlert({
        title: "Success",
        text:"Are you sure you want to update this record?",
        confirmButtonText: "Lead Status updated successfully.",
        icon: "success",
        confirmButtonText: "OK",
        callback: () => {
          navigate(ROUTES_NAVIGATION.LEADSTATUSLIST);  // Navigate after user clicks OK
        },
      });

    } catch (error) {
      console.error("Error updating lead status:", error);
    }
  };

  const CustomerInputs = [
    ...(userType === "superadmin"
      ? [
          {
            name: "business_partner_id",
            label: "Business Partner",
            type: "dropdown",
            required: true,
            options: userTypedd,
            gridClass: "col-lg-4",
           
          },
        ]
      : []),
    {
      name: "status_name",
      label: "Name",
      type: "text",
      required: true,
    validation: { required: true,
      pattern: /^[A-Za-z\s]*$/,
      message: "First Letter Should be Capital & Only alphabets are allowed*",
     },
      gridClass: "col-lg-4",
  
    },
    {
      name: "status_desc",
      label: "Description",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      options: [
        { label: "Active", value: "Active" },
        { label: "Inactive", value: "Inactive" },
      ],
      validation: {
        required: true,
        message: "Status is required",
      },
      gridClass: "col-lg-4",
    },
    
  ];

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
      <div className="backbutton mt-2 mb-2">
        <img src={backicon} alt="back" onClick={() => navigate(ROUTES_NAVIGATION.LEADSTATUSLIST)} />
        <span className="backbtntitle">Edit Lead Status</span>
      </div>
      <div className="form-container">
        <span className="cust-det-title mt-2 mb-2">
          Please Edit the Lead Status Details
        </span>
        <DynamicForm
          formConfig={CustomerInputs}
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleFormSubmit}
          validationErrors={validationErrors}
          setValidationErrors={setValidationErrors}
        />
      </div>
      <div className="btncontainer mt-3">
        <button
          onClick={() => handleFormSubmit(formData)}
          className="submit-btn"
        >
          Submit
        </button>
      </div></>
      )}
    </>
  );
};

export default EditLeadStatus;
